'use client';

import type * as React from 'react';
import { useTabListBase_unstable } from '@fluentui/react-tabs';

import type { TabListProps, TabListState } from './TabList.types';

/**
 * Returns the state for a TabList component, given its props and ref.
 * The returned state can be modified with hooks before being passed to `renderTabList`.
 */
export const useTabList = (props: TabListProps, ref: React.Ref<HTMLElement>): TabListState => {
  const state: TabListState = useTabListBase_unstable(props, ref);

  // eslint-disable-next-line react-hooks/immutability
  state.root.focusgroup = state.vertical ? 'tablist block wrap no-memory' : 'tablist inline wrap no-memory';
  // eslint-disable-next-line react-hooks/immutability
  state.root['data-orientation'] = state.vertical ? 'vertical' : 'horizontal';

  return state;
};
